const ShopifyIcon = () => (
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_86_19229)">
      <g clipPath="url(#clip1_86_19229)">
        <path
          d="M15.0693 1C15.6085 1 16.2248 1.28295 16.7383 1.95117H16.8926C18.6642 1.95117 19.6656 3.46741 20.2305 5.1123C20.7944 4.93269 21.1539 4.83043 21.1807 4.83008C21.309 4.77867 21.6943 4.72731 21.874 4.90723C22.0802 5.08794 23.7744 6.7832 23.7744 6.7832C23.802 6.78524 26.2131 6.9628 26.3418 6.96289C26.4701 6.96289 26.5982 7.06572 26.624 7.21973C26.6496 7.3992 30.0991 30.7506 30.1162 30.8662L20.2305 33L2 29.5811C2.01291 29.4809 4.33703 11.4589 4.43945 10.8438C4.54212 9.99597 4.56825 9.97018 5.4668 9.6875C5.59689 9.63559 6.75147 9.27593 8.3418 8.78809C8.95803 6.16647 10.9355 1.00026 15.0693 1ZM14.9414 2.10742C11.9888 2.10774 10.3202 5.98864 9.62695 8.37891C10.4228 8.14763 11.2698 7.89009 12.1426 7.60742C12.7332 4.47189 14.172 2.90396 15.4814 2.28711C15.3017 2.1586 15.1211 2.10742 14.9414 2.10742ZM16.1738 3.26367C15.1725 3.70071 14.0176 4.85755 13.4014 7.19629C14.4797 6.86219 15.5837 6.52813 16.585 6.21973V6.04004C16.585 4.80631 16.4306 3.90624 16.1738 3.26367ZM17.3037 3.08008C17.5091 3.72263 17.6631 4.54519 17.6631 5.57324V5.90723C18.2278 5.72738 18.7411 5.57311 19.2031 5.41895C18.818 4.21114 18.2278 3.1831 17.3037 3.08008Z"
          fill="#95BF47"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.3416 6.96306C26.2132 6.96306 23.7739 6.78314 23.7739 6.78314C23.7739 6.78314 22.0792 5.08675 21.8738 4.90683C21.7968 4.82973 21.7197 4.80402 21.617 4.77832L20.2305 33L30.1161 30.8666C30.1161 30.8666 26.6497 7.4 26.6241 7.24579C26.5984 7.06587 26.4443 6.98876 26.3416 6.96306Z"
          fill="#5E8E3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8675 12.4396L15.6606 16.0637C15.6606 16.0637 14.5822 15.4983 13.2983 15.4983C11.3726 15.4983 11.2955 16.7063 11.2955 17.0147C11.2955 18.6597 15.6093 19.3023 15.6093 23.1834C15.6093 26.242 13.6835 28.1954 11.0644 28.1954C7.93182 28.1954 6.33984 26.242 6.33984 26.242L7.18719 23.4661C7.18719 23.4661 8.83052 24.8798 10.2171 24.8798C11.1158 24.8798 11.5009 24.1601 11.5009 23.6461C11.5009 21.487 7.9575 21.3842 7.9575 17.8372C7.9575 14.8557 10.0887 11.9513 14.4281 11.9513C16.0458 11.9513 16.8675 12.4396 16.8675 12.4396Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_86_19229">
        <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
      </clipPath>
      <clipPath id="clip1_86_19229">
        <rect y="1" width="32" height="32" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ShopifyIcon;
